/**
 * Presigned upload flow: ask the API for a PUT URL, send the file straight to
 * storage (S3 in hosted mode — bypassing Lambda's 6MB request cap; a local
 * direct-PUT endpoint in dev), then hand the uploadKey to a from-key route.
 */
import { PresignResponse } from "@reina/shared";
import { api } from "../api/client";

export async function uploadViaPresign(
  file: File,
  kind: "price_list" | "buy_list",
): Promise<{ uploadKey: string; filename: string }> {
  const presign = await api.post(
    "/uploads/presign",
    { filename: file.name, mime: file.type || null, kind },
    { schema: PresignResponse },
  );

  const isLocal = presign.url.startsWith("/");
  const response = await fetch(presign.url, {
    method: "PUT",
    body: file,
    // The S3 presigned URL signs the content-type when one was provided.
    headers: file.type ? { "content-type": file.type } : undefined,
    credentials: isLocal ? "include" : "omit",
  });
  if (!response.ok) {
    throw new Error(`file upload failed (${response.status})`);
  }
  return { uploadKey: presign.uploadKey, filename: file.name };
}
